import { CircularProgress, Stack, styled } from '@mui/material'
import { Typography } from '../../text'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { IconButton } from '../../buttons/IconButton/IconButton'
import { X } from '@phosphor-icons/react'
import { isValidElement, ReactNode } from 'react'

export type ModalHeaderProps = {
    title: ReactNode
    handleCloseModal: () => void
    showCloseIcon?: boolean
    showLoading?: boolean
    closeIconTooltip?: string
}

export function ModalHeader({ title, handleCloseModal, showCloseIcon = false, showLoading = false, closeIconTooltip }: ModalHeaderProps) {
    // TODO: (Piazza) replace with Headline component
    return (
        <ModalHeaderContainer>
            {isValidElement(title) ? (
                title
            ) : (
                <Stack direction="row" gap={tokens.SizingSpacing300} alignItems="center">
                    <Typography color={tokens.ColorTextBoldest} variant="headline1">
                        {title}
                    </Typography>
                    {showLoading && <CircularProgress sx={{ position: 'relative', top: 0, left: 0 }} size={24} thickness={3} />}
                </Stack>
            )}
            {showCloseIcon && (
                <IconButton
                    ariaLabel="close-modal"
                    variant="tertiary"
                    size="medium"
                    icon={<X />}
                    onClick={handleCloseModal}
                    tooltip={closeIconTooltip ?? 'Schließen'}
                />
            )}
        </ModalHeaderContainer>
    )
}

const ModalHeaderContainer = styled(Stack)`
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: ${tokens.SizingSpacing150};
    padding: ${tokens.SizingSpacing150} ${tokens.SizingSpacing300};
    border-bottom: ${tokens.SizingBorderS} solid ${tokens.ColorBorderDefault};
    background: ${tokens.ColorSurfaceDefault};
    box-sizing: border-box;
`
